import React, { useState } from "react";
import { isNullOrWhitespace } from "../../../../utilities/string";
import "../form.scss";

export interface dateboxProps {
    id: string;
    label?: string;
    value: string;
    initializeDefault?: boolean;
    onChange: (newValue: string) => any;
    setFocus?: boolean;
    firstCol?: number;
    noBorder?: boolean;
    disabled?: boolean;
}

const getDefaultDate = () => {
    return new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, -14);
};

function DateControl(props: dateboxProps) {
    const [fieldValue, setFieldValue] = useState("");

    React.useEffect(() => {
        if (props.value === "" && !props.disabled && props.initializeDefault) {
            let defaultVal = getDefaultDate();
            setFieldValue(defaultVal);
            props.onChange(defaultVal);
        } else {
            setFieldValue(props.value);
        }
    }, [props.value]);
    const handleInputChange = (e: React.FormEvent<HTMLInputElement>) => {
        setFieldValue(e.currentTarget.value);
        props.onChange(e.currentTarget.value);
    };

    return (
        <div
            className="row rowMarginControl"
            key={"Main" + props.id}
        >
            {props.label && (
                <div className={props.firstCol == undefined ? "col-sm-3" : "col-sm-" + props.firstCol}>
                    <label className="g-label">{props.label}</label>
                </div>
            )}
            <div className={props.firstCol == undefined ? "col-sm-9" : "col-sm-" + (12 - props.firstCol)}>
                <input
                    type={props.disabled && isNullOrWhitespace(fieldValue) ? "text" : "date"}
                    className="g-TextBox-default"
                    style={{ borderWidth: props.noBorder ? "0px" : "1px" }}
                    onChange={handleInputChange}
                    value={fieldValue}
                    disabled={props.disabled}
                />
            </div>
        </div>
    );
}
export default DateControl;
